import React from 'react'
import { SubText, TitleH3 } from 'components/Common/Typography'
import { Container, Row, Col } from 'react-bootstrap'
import Image from 'next/image'

const CmmiInfoSection = (props: { className: any }) => {
  const { className } = props
  return (
    <section className={`cmmi_info_section py-5 ${className}`}>
      <Container className="py-2 py-lg-4">
        <Row className="align-items-center flex-md-row-reverse">
          <Col lg={5}>
            <div className="text-center">
              <Image
                src="/assets/images/about-us/cmmi-logo.svg"
                alt="Webclues - CMMI Level 5"
                height={158}
                width={240}
              />
            </div>
          </Col>
          <Col lg={7} className="text-center text-lg-start mt-5 mt-lg-0">
            <TitleH3
              text="We are a CMMI level 5 certified company"
              className="pb-2 fs-xxl-40px"
            />
            <SubText
              className="mb-0 text-light"
              text="Our innovative process, technological improvements, and relentless commitment to delivering the finest quality of services to our clients have made us earn this authoritative certification."
            />
          </Col>
        </Row>
      </Container>
      <a id="blogTimeeline">&nbsp;</a>
    </section>
  )
}

export default CmmiInfoSection
